export default __webpack_public_path__ + "static/media/JimBertram.afe81776.jpg";